module.exports = __webpack_public_path__ + "img/child-of-love2.f71aff37.jpg";